import { Main } from 'components/ActionStyles/ActionStyles'
import Button from 'components/Button'
import React from 'react'

const ActionDropdown = ({ setIsDownloadDrawerVisible ,studentUrl,disabled,setUrlStudent,docDetails,setDocDetails}) => {

  const handleActionClick = () => {
    setIsDownloadDrawerVisible(true)
    setUrlStudent(studentUrl)
    setDocDetails(docDetails)
  }
    return (
    <Main id="view_dropdown">
      <Button.Secondary
        width="69px"
        height="38px"
        text="View"
        htmlType="submit"
        onClick={handleActionClick}
        disabled={disabled}
      />
    </Main>
  )
}

export default ActionDropdown
